//** Menu */
export const MENU_SECTIONS = 'MENU_SECTIONS'
export const MENU_PRODUCT_MANAGEMENT = 'MENU_PRODUCT_MANAGEMENT'
export const MENU_PRODUCT = 'MENU_PRODUCT'
export const STORE_STATE = 'STORE_STATE'
export const STORE_AREA_TIMEZONE = 'STORE_AREA_TIMEZONE'
export const STORE_PRICE_TIER = 'STORE_PRICE_TIER'
export const STORES_CHANNELS = 'STORES_CHANNELS'
export const STORE_MENU = 'STORE_MENU'

//** Loyalty */
export const LOYALTY_SLICE_NAME = 'gygLoyalty'
export const GET_LOYALTY_BY_USER_ID_ACTION = `${LOYALTY_SLICE_NAME}/getLoyaltyByUserId`
export const UPDATE_GYG_POINTS_DOLLAR = `${LOYALTY_SLICE_NAME}/updateGYGPointDollar`

//** Calendar Events and Events data */
export const TRADING_HOURS_EVENT = 'TRADING_HOURS_EVENT'
export const CLEANING_SCHEDULE_EVENT = 'CLEANING_SCHEDULE_EVENT'
export const EVENTS_DATA = 'EVENTS_DATA'
